<div class="bk-panel rv">
  <section class="rv__section" aria-labelledby="rv-info-title">
    <header class="rv__head">
      <h2 class="bk-section-title rv__title" id="rv-info-title">Name and description</h2>
      <button type="button" class="bk-more rv__edit" (click)="editSegmentDetails()" aria-label="Edit the name and description">
        <span class="bk-sym" aria-hidden="true">edit</span>
        Edit
      </button>
    </header>
    <dl class="bk-kv">
      <dt>Name</dt>
      <dd>{{ segmentService.segmentInformation.segmentName || '—' }}</dd>
      <dt>Description</dt>
      <dd>{{ segmentService.segmentInformation.description || '—' }}</dd>
    </dl>
  </section>

  <section class="rv__section" aria-labelledby="rv-rules-title">
    <header class="rv__head">
      <h2 class="bk-section-title rv__title" id="rv-rules-title">Conditions</h2>
      <button type="button" class="bk-more rv__edit" (click)="editSegmentRules()" aria-label="Edit the conditions">
        <span class="bk-sym" aria-hidden="true">edit</span>
        Edit
      </button>
    </header>
    @if (conditions.length) {
      <p class="rv__lead">Contacts must match all of these.</p>
      <ol class="rv__rules">
        @for (condition of conditions; track $index) {
          <li class="rv__rule">
            <span class="rv__join">{{ $first ? 'If' : 'And' }}</span>
            <span class="rv__text">{{ condition }}</span>
          </li>
        }
      </ol>
    } @else {
      <p class="rv__lead">No conditions yet. Add at least one before saving.</p>
    }
  </section>
</div>
